import { render } from "./Whatsapp.vue?vue&type=template&id=309d97d9"
import script from "./Whatsapp.vue?vue&type=script&lang=js"
export * from "./Whatsapp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__